import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './VerificationEmailInput';
import { getVerificationLoadingState } from '../publicSession/selectors';
import { updateEmail } from '../publicSession/actions';

export type StateProps = Pick<
  Props,
  'isResendInProgress' | 'isEmailChangeInProgress' | 'updateFailed'
>;
export type DispatchProps = Pick<Props, 'changeEmail'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state): StateProps => getVerificationLoadingState(state);
const mapDispatchToProps: DispatchProps = {
  changeEmail: updateEmail,
};

export default connect(mapStateToProps, mapDispatchToProps) as (
  component: ComponentType<Props>
) => ComponentType<OwnProps>;
